import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "fill-current text-red mr-1",
    icon: "IconExclamationCircle",
    size: 16
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-red text-13px"
  }, children));
};
ErrorMessage.propTypes = {
  children: PropTypes.node.isRequired
};
export default ErrorMessage;
//# sourceMappingURL=index.js.map